import Badge from './Badge';

export default {
  id: 'radial_2',
  title: 'Radial_2',
  colors: 3,
  animated: true,
  premium: true,
  BadgeComponentStateless: Badge
};
